(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('category', {
                parent: 'admin',
                abstract: true,
                data: {
                    authorities: [],
                    pageTitle: 'category.home.title'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/flyers/category-flyer/category-flyer.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('categorys');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            }).state('categorys-list', {
                parent: 'category',
                url: '/categorys-list',
                data: {
                    pageTitle: 'categorys.title',
                    authorities: []
                },
                views: {
                    'category-list': {
                        templateUrl: 'app/admin/flyers/category-flyer/category-flyer-list.html',
                        controller: 'CategoryFlyerListController',
                        controllerAs: 'vm'
                    }
                }
            });
    }
})();
